import {
  ServerFile2veqsg2df5jtr as ServerFile,
  _ServerFile___get_location__impl__ddyqaq3gnot90we5jhf as _ServerFile___get_location__impl__ddyqaq,
  _ServerFile___init__impl__jj3mn21a24gf5791tmu as _ServerFile___init__impl__jj3mn2,
} from './ServerFile.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import {
  InliningSerialDescriptoruyfh24595vup as InliningSerialDescriptor,
  PrimitiveDescriptorWithAnnotations1b27un5ddu1g9 as PrimitiveDescriptorWithAnnotations,
} from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { Description1f0zycfwk0zld as Description } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DeferToContextualServerFileSerializerClass;
function DeferToContextualServerFileSerializer() {
  if (DeferToContextualServerFileSerializerClass === VOID) {
    class $ {
      constructor() {
        DeferToContextualServerFileSerializer_instance = this;
        var tmp = this;
        var tmp_0 = getKClass(ServerFile());
        var tmp_1 = DirectServerFileSerializer_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$0 = [];
        tmp.c_1 = ContextualSerializer().new_kotlinx_serialization_ContextualSerializer_niymzz_k$(tmp_0, tmp_1, tmp$ret$0);
        this.descriptor_1 = new (InliningSerialDescriptor())('com.lightningkite.services.files.ServerFile', this.c_1.descriptor_1);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_re1zxi_k$(decoder) {
        return decoder.decodeInline_ux3vza_k$(this.descriptor_1).decodeSerializableValue_xpnpad_k$(this.c_1).location_1;
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ServerFile())(this.deserialize_re1zxi_k$(decoder));
      }
      serialize_vzs1of_k$(encoder, value) {
        return encoder.encodeInline_wxp5pu_k$(this.descriptor_1).encodeSerializableValue_3uuzip_k$(this.c_1, new (ServerFile())(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_vzs1of_k$(encoder, value instanceof ServerFile() ? value.location_1 : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DeferToContextualServerFileSerializer', VOID, VOID, [KSerializer()]);
    DeferToContextualServerFileSerializerClass = $;
  }
  return DeferToContextualServerFileSerializerClass;
}
var DeferToContextualServerFileSerializer_instance;
function DeferToContextualServerFileSerializer_getInstance() {
  if (DeferToContextualServerFileSerializer_instance === VOID)
    new (DeferToContextualServerFileSerializer())();
  return DeferToContextualServerFileSerializer_instance;
}
var DirectServerFileSerializerClass;
function DirectServerFileSerializer() {
  if (DirectServerFileSerializerClass === VOID) {
    class $ {
      constructor() {
        DirectServerFileSerializer_instance = this;
        this.descriptor_1 = new (PrimitiveDescriptorWithAnnotations())('com.lightningkite.services.files.ServerFile', STRING_getInstance(), listOf(new (Description())('A URL referencing a file that the server owns.')));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_vzs1of_k$(encoder, value) {
        encoder.encodeString_424b5v_k$(_ServerFile___get_location__impl__ddyqaq(value));
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_vzs1of_k$(encoder, value instanceof ServerFile() ? value.location_1 : THROW_CCE());
      }
      deserialize_re1zxi_k$(decoder) {
        return _ServerFile___init__impl__jj3mn2(decoder.decodeString_x3hxsx_k$());
      }
      deserialize_sy6x50_k$(decoder) {
        return new (ServerFile())(this.deserialize_re1zxi_k$(decoder));
      }
    }
    initMetadataForObject($, 'DirectServerFileSerializer', VOID, VOID, [KSerializer()]);
    DirectServerFileSerializerClass = $;
  }
  return DirectServerFileSerializerClass;
}
var DirectServerFileSerializer_instance;
function DirectServerFileSerializer_getInstance() {
  if (DirectServerFileSerializer_instance === VOID)
    new (DirectServerFileSerializer())();
  return DirectServerFileSerializer_instance;
}
//region block: exports
export {
  DeferToContextualServerFileSerializer_getInstance as DeferToContextualServerFileSerializer_getInstancebet21aefs4ur,
};
//endregion

//# sourceMappingURL=DirectServerFileSerializer.mjs.map
